export default {
	TaxReturnRegisHistoryData: function(state) {
		return state.TaxReturnRegisHistoryData;
	},
	Total: function(state) {
		return state.Total;
	},
	ListHistoryRegister: function(state) {
		return state.ListHistoryRegister;
	},
	TotalHistoryRegister: function(state) {
		return state.TotalHistoryRegister;
	}
};
